import { MUIDataTableColumn, MUIDataTableMeta } from 'mui-datatables';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen, faTrash } from '@fortawesome/free-solid-svg-icons';
import CustomTable from '../../common/components/CustomTable/CustomTable';
import IPlatform from '../../interfaces/Platform';

const PlatformsColumns = (props: {
  onEditClick: (tableMeta: MUIDataTableMeta<IPlatform>) => void,
  onDeleteClick: (tableMeta: MUIDataTableMeta<IPlatform>) => void,
  platforms: IPlatform[],
  searchParam?: string
}) => {

  const { platforms, searchParam, onEditClick, onDeleteClick } = props

  const platformsColumns: MUIDataTableColumn[] = [
    {
      name: "id",
      label: "Id",
      options: {
        display: false
      }
    },
    {
      name: "name",
      label: "Nome",
    },
    {
      name: "code",
      label: "Codice",
      options: {
        filterList: []
      }
    },
    {
      name: "azioni",
      label: "Azioni",
      options: {
        customBodyRender: (value: any, tableMeta: MUIDataTableMeta<IPlatform>, updateValue: any) => (
          <>
            <Button className='btn btn-primary rounded-circle me-1 shadow-sm' onClick={() => onEditClick(tableMeta)}><FontAwesomeIcon icon={faPen} /></Button>
            <Button className='btn btn-danger rounded-circle shadow-sm' onClick={() => onDeleteClick(tableMeta)}><FontAwesomeIcon icon={faTrash} /></Button>
          </>
        )
      }
    },
  ]

  const filteredCols = searchParam ? [...platformsColumns] : [];

  if (searchParam) {
    let filterList: string[] = [];
    if (searchParam !== "All") {
      filterList = [searchParam];
    }
    // Target the column to filter on.
    let colWithFilter = filteredCols.find(col => col.options && col.options.filterList)
    if (colWithFilter && colWithFilter.options && colWithFilter.options.filterList)
      colWithFilter.options.filterList = filterList;
  }

  return (
    <CustomTable
      title={"Elenco di tutte le piattaforme disponibili"}
      data={platforms}
      columns={filteredCols.length !== 0 ? filteredCols : platformsColumns}
    />
  )
}

export default PlatformsColumns;